<p>{{ 'reporting_UPLOAD_CONSUMER_DATA_HELP_TEXT' | translate }}</p>
@if (view$ | async; as view) {
    <div>
        <div class="row mb-3 g-5">
            @for (account of view.accounts; track account) {
                <div class="col-12 col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="row key-value-group">
                                <div class="col-4 text-end">
                                    <b> {{ 'reporting_ACCOUNT' | translate }}</b>
                                </div>
                                <div class="col-8 text-start">
                                    {{ account.accountHeading }}
                                </div>
                            </div>
                            <div class="row key-value-group">
                                <div class="col-4 text-end">
                                    <b> {{ 'reporting_ACCOUNTING_PERIOD' | translate }}</b>
                                </div>
                                <div class="col-8 text-start">
                                    {{ account.periodStartDate | appdate }} -
                                    {{ account.periodEndDate | appdate }}
                                </div>
                            </div>
                            @if (
                                account.consumerState === 'OPEN' &&
                                account.consumerAmountsAcceptedDate === null
                            ) {
                                <div class="dropzone mb-2">
                                    <input
                                        type="file"
                                        multiple
                                        (change)="
                                            uploadAttachment(
                                                $event,
                                                view.selectedAccount.building.buildingNo,
                                                view.periodId,
                                                account
                                            )
                                        " />
                                    <i class="bi bi-inbox" style="font-size: 21px"></i>
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        style="width: 100%">
                                        {{ 'reporting_BROWSE_FILES' | translate }}
                                    </button>
                                </div>
                            }
                            @for (file of account.attachments; track file; let index = $index) {
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <i class="bi bi-file-earmark me-2"></i>
                                        {{ file.filename }} -
                                        {{ formatBytes(file.attachmentSize) }}
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            class="btn btn-text-primary"
                                            (click)="attachmentsUtil.downloadAttachment(file)">
                                            <i class="bi bi-file-earmark-arrow-down"></i>
                                        </button>
                                        @if (
                                            account.consumerState === 'OPEN' &&
                                            account.consumerAmountsAcceptedDate === null
                                        ) {
                                            <button
                                                type="button"
                                                class="btn btn-text-danger"
                                                (click)="
                                                    deleteAttachment(
                                                        file,
                                                        view.selectedAccount.building.buildingNo,
                                                        view.periodId,
                                                        account
                                                    )
                                                ">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                            @if (account.consumerAmountsAcceptedDate === null) {
                                <button
                                    class="btn btn-primary w-100"
                                    (click)="approve(view.periodId, view.selectedAccount, account)">
                                    {{ 'reporting_Approve' | translate }}
                                </button>
                            }
                            @if (account.uploading) {
                                <app-load />
                            }
                            <div class="mt-3">
                                @if (account.attachments.length === 0) {
                                    <p>
                                        {{ 'reporting_NO_FILE_ATTACHMENT' | translate }}
                                    </p>
                                }
                                @if (account.consumerAmountsAcceptedDate != null) {
                                    <p>
                                        {{
                                            ('reporting_approved_text' | translate).replace(
                                                '{0}',
                                                account.consumerAmountsAcceptedDate | appdate
                                            )
                                        }}
                                    </p>
                                }
                                @if (account.costsAcceptedDate != null) {
                                    <p>
                                        {{
                                            (
                                                'reporting_requested_and_approved_text' | translate
                                            ).replace(
                                                '{0}',
                                                (account.costsAcceptedDate | appdate) ?? ''
                                            )
                                        }}
                                    </p>
                                }
                                @if (account.costState === 'OPEN') {
                                    <p>
                                        {{ 'reporting_requested_not_approved_text' | translate }}
                                    </p>
                                }
                            </div>
                            <div class="mb-3">
                                <a
                                    [routerLink]="['../../costs', account.accountPeriodId]"
                                    (click)="
                                        reportingService.setActiveAccount(
                                            view.selectedAccount.building,
                                            account
                                        )
                                    ">
                                    @if (account.costState === 'OPEN') {
                                        {{ 'reporting_report_cost_information' | translate }}
                                    }
                                    @if (account.costState === 'VIEW') {
                                        {{ 'reporting_view_costs' | translate }}
                                    }
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div>
            <a class="me-2" [routerLink]="['../../']">{{
                'reporting_go_to_list_of_accounts' | translate
            }}</a>
            @if (!view.attachmentsExistsOnAnAccount) {
                <a [routerLink]="[]" (click)="gotoManualReporting.next()">
                    {{ 'reporting_go_to_manual_input' | translate }}
                </a>
            }
        </div>
    </div>
} @else {
    <app-load />
}
